var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGorilla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5748",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 301.4 301.4",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-111.39 -295.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect4149",
    className: "st0",
    d: "M111.4 295.8h301.4v301.4H111.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4145",
    transform: "translate(19.784 -22.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5499",
    transform: "translate(-99.675 155.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text6016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4147",
    d: "M267.8 448c-2 0-3.7-.6-5.1-1.7-1.4-1.1-2.1-2.5-2.1-4.1v-8.6c0-1.6.7-2.9 2.1-4.1 1.4-1.1 3.1-1.7 5.1-1.7h14.7c.7 0 1.1.4 1.1 1.1v.7c0 .7-.4 1.1-1.1 1.1h-14.7c-1 0-1.8.3-2.5.8-.7.6-1 1.2-1 2v8.6c0 .8.3 1.5 1 2 .7.6 1.5.8 2.5.8H280v-7.5c0-.7.4-1.1 1.1-1.1h1.4c.7 0 1.1.4 1.1 1.1v9.3c0 .7-.4 1.1-1.1 1.1h-14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4149",
    d: "M290 442.3c0 .8.3 1.5 1 2 .7.6 1.5.8 2.5.8h8.6c1 0 1.8-.3 2.5-.8.7-.6 1-1.2 1-2v-8.6c0-.8-.3-1.5-1-2-.7-.6-1.5-.8-2.5-.8h-8.6c-1 0-1.8.3-2.5.8-.7.6-1 1.2-1 2v8.6zm19.4 0c0 1.6-.7 2.9-2.1 4.1-1.4 1.1-3.1 1.7-5.1 1.7h-8.6c-2 0-3.7-.6-5.1-1.7-1.4-1.1-2.1-2.5-2.1-4.1v-8.6c0-1.6.7-2.9 2.1-4.1 1.4-1.1 3.1-1.7 5.1-1.7h8.6c2 0 3.7.6 5.1 1.7 1.4 1.1 2.1 2.5 2.1 4.1v8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4151",
    d: "M315.8 436.6H328c1 0 1.8-.3 2.5-.8.7-.6 1-1.2 1-2s-.3-1.5-1-2c-.7-.6-1.5-.8-2.5-.8h-12.2v5.6zm7.2 2.9h-7.2v7.5c0 .7-.4 1.1-1.1 1.1h-1.4c-.7 0-1.1-.4-1.1-1.1v-17.9c0-.7.4-1.1 1.1-1.1H328c2 0 3.7.6 5.1 1.7 1.4 1.1 2.1 2.5 2.1 4.1 0 1.6-.7 2.9-2.1 4.1-1.4 1.1-3.1 1.7-5.1 1.7h-.6l7 6.4c.5.5.7.8.7 1.1 0 .7-.4 1.1-1.1 1.1h-1c-.5 0-1.1-.4-1.8-1.1l-8.2-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4153",
    d: "M341.6 447c0 .7-.4 1.1-1.1 1.1h-1.4c-.7 0-1.1-.4-1.1-1.1v-17.9c0-.7.4-1.1 1.1-1.1h1.4c.7 0 1.1.4 1.1 1.1V447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4155",
    d: "M344.5 429.1c0-.7.4-1.1 1.1-1.1h1.4c.7 0 1.1.4 1.1 1.1v13.3c0 .8.3 1.5 1 2 .7.6 1.5.8 2.5.8h14.7c.7 0 1.1.4 1.1 1.1v.7c0 .7-.4 1.1-1.1 1.1h-14.7c-2 0-3.7-.6-5.1-1.7-1.4-1.1-2.1-2.5-2.1-4.1l.1-13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4157",
    d: "M370.3 429.1c0-.7.4-1.1 1.1-1.1h1.4c.7 0 1.1.4 1.1 1.1v13.3c0 .8.3 1.5 1 2 .7.6 1.5.8 2.5.8h14.7c.7 0 1.1.4 1.1 1.1v.7c0 .7-.4 1.1-1.1 1.1h-14.7c-2 0-3.7-.6-5.1-1.7-1.4-1.1-2.1-2.5-2.1-4.1l.1-13.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path6020",
    d: "M399.8 446.7c-.6.9-1.2 1.3-1.7 1.3h-1.3c-.9 0-1.3-.4-1.3-1.3 0-.3.1-.7.4-1.3l11.3-20.5c.3-.9.7-1.3 1.3-1.3h1.7c.6 0 1 .4 1.3 1.3l11.3 20.5c.3.6.4 1 .4 1.3 0 .9-.4 1.3-1.3 1.3h-1.3c-.6 0-1.2-.4-1.7-1.3l-9.6-18c-3.1 6-6.3 12-9.5 18z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon6002",
    d: "M228.3 573.2l26-26v-23l-26 26v23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6004",
    d: "M197.4 559.8l26-26v-23l-26 26v23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6006",
    d: "M236.6 435.9l-3.4 3.4 33.3 33.3 4.4-4.1v-2.2h-3.4l3.4-3.3v-8.4l-5.9-5.7 3.5-3.5-9.5-9.3-22.4-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6008",
    d: "M270.7 418.8v26l5 5 4.1-4.1v46.9L299 473v-25.8l-28.3-28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6010",
    d: "M185.6 548.6l11.8-11.8v-10.3l-11.8 11.8v10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon6012",
    d: "M185.7 334v102.4l42.7 42.8v64.4l51.4-51.1-51.4-51.1-.1-28.8-12.9-23.5 12.9 12.9v-25.6L185.7 334z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGorilla);
export default __webpack_public_path__ + "static/media/gorilla.1ba69529bb85e2f504370694eb57ac79.svg";
export { ForwardRef as ReactComponent };